export default "__VITE_ASSET__CJ6OhJT7__"